<!--       - Bice lista kupljenih poklona <br>-->
<!--       - Svaki poklon ce da ima od podatka (Naziv artikla, barcode, opis i ime dobavljaca) <br>-->
<!--       - Artikli ce biti poredjani na denvnom nivou, recimo 22.11 kupljene tri igracke pa 23.11 kupljene 8 igracke <br>-->
<!--       - Postojace dugme gde ce moci da se skine pdf sa poklonima, kako bi oni poslali dobavljacima sta hoce da naruce-->
<!--      <br>-->
<!--       - Imace filter po prodavnici da na osnovu toga mzoe da i odstampa pdf <br>-->
<!--       - Ubaciti datepicker kako bi sortirali po datumu sta zele da stampaju <br>-->
<!--       - prikazati inicajalno posljenjih 30 dana-->
<div class="tab-gifts">
  <div class="grid">
    <div class="grid__m-4">
      <div class="label-reservations">
        <span>Izaberite datum</span>
      </div>
      <gr-date-picker [minDate]="minDate" [defaultDate]="urlParams.date ? urlParams.date : undefined" (dateSelected)="onSelectedDate($event)"></gr-date-picker>
    </div>
    <div class="grid__m-4">
      <div class="label-reservations">
        <span>Izaberite prodavnicu igračaka</span>
      </div>
      <gr-dropdown
        [items]="stores"
        [propIdentifier]="'id'"
        [dropdownLabel]="'Prodavnica igračaka'"
        [placeholder]="'Prodavnica igračaka'"
        (selectItem)="onSelectedSupplier($event)">
      </gr-dropdown>
    </div>
    <div class="grid__m-2">
      <button (click)="exportBoughtGiftsPdf()" class="zc-btn zc-btn--primary">
        <span>Štampaj PDF</span>
      </button>
    </div>
    <div class="grid__m-2">
      <button (click)="exportBoughtGiftsExcel()" class="zc-btn zc-btn--primary">
        <span>Štampaj Excel</span>
      </button>
    </div>
  </div>
  <div class="grid">
    <div class="grid__m-12">
      <div class="zc-table purchased-gift bought-gifts">
        <div class="zc-header-table">
          <div class="zc-header-row">
            <div class="zc-header-column">
              <span>Datum</span>
            </div>
            <div class="zc-header-column">
              <span>Barcode</span>
            </div>
            <div class="zc-header-column">
              <span>Naziv igračke</span>
            </div>
            <div class="zc-header-column">
              <span>Količina</span>
            </div>
            <div class="zc-header-column">
              <span>Opis</span>
            </div>
            <div class="zc-header-column">
              <span>Ime dobavljača</span>
            </div>
          </div>
        </div>
        <div class="zc-content-table">
          <div *ngFor="let gift of gifts" class="zc-content-row">
            <div class="zc-content-column">
              <span>{{ gift.reservation_date | date: 'dd.MM.yyyy' }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ gift.barcode }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ gift.name }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ gift.quantity }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ gift.description }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ gift.supplier }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

